/* DTFJOKER — estimated delivery box.
   Delivery is NOT computed from transit math: it is a fixed table the merchant
   confirmed from real UPS history, keyed by the US Eastern weekday the order
   is placed on (Sun→Wed, Mon→Thu, Tue→Thu, Wed→Fri, Thu→Mon, Fri→Mon, Sat→Tue).
   The row is chosen by the SHIP-OUT date in Istanbul, not the order date:
   orders are printed and handed to the carrier on the day whose 06:00 Istanbul
   cut-off they fall before, so 03:00 Wednesday still ships Wednesday while
   13:45 Tuesday ships Wednesday. Sunday never ships, so a
   Sunday ship-out rolls to Monday. Everything
   runs on the visitor's clock converted to a fixed zone, so a shopper in Los
   Angeles and one in New York see the same date. No app, no network.
   Nothing about Istanbul, hand-over times or closures is ever shown.
   The table gives the EARLIEST arrival; data-spread-days widens it into a
   range (Saturday/Sunday endings roll to Monday — no weekend delivery).
   The copy never mentions closed days or a missed cutoff — only the date. */
(function () {
  'use strict';
  // 19 Sep 2026: Monday corrected 3 -> 2 (Monday ship-out arrives Wednesday).
  var TABLE = [3, 2, 2, 2, 4, 3, 3];   // index = weekday in SHIP_TZ, 0 = Sunday
  var SHIP_TZ = 'Europe/Istanbul';     // where the parcel is handed to the carrier
  var SHIP_CUTOFF_HOUR = 6;            // 06:00 Istanbul — after this, next day's shipment
  var COUNTDOWN_WINDOW_HOURS = 12;     // countdown visible only in the last 12h before the cutoff

  function init() {
    var box = document.querySelector('[data-dtfj-delivery]');
    if (!box) return;
    var TZ = box.getAttribute('data-tz') || 'America/New_York';
    var cut = (box.getAttribute('data-cutoff') || '15:00').split(':');
    var cutH = parseInt(cut[0], 10); if (isNaN(cutH)) cutH = 15;
    var cutM = parseInt(cut[1], 10) || 0;
    var dateEl = box.querySelector('[data-dtfj-delivery-dates]');
    var noteEl = box.querySelector('[data-dtfj-delivery-note]');
    var timeEl = box.querySelector('[data-dtfj-delivery-left]');
    var shipEl = box.querySelector('[data-dtfj-delivery-ship]');
    if (!dateEl) return;

    function nowIn(zone) {
      return new Date(new Date().toLocaleString('en-US', { timeZone: zone }));
    }
    function addDays(d, n) { var c = new Date(d.getTime()); c.setDate(c.getDate() + n); return c; }
    function pad(n) { return n < 10 ? '0' + n : '' + n; }

    function render() {
      var now = nowIn(TZ);             // used for the local cutoff note only
      var basis = nowIn(SHIP_TZ);      // the row is keyed to the ship-out date
      if (basis.getHours() >= SHIP_CUTOFF_HOUR) basis = addDays(basis, 1);
      if (basis.getDay() === 0) basis = addDays(basis, 1);   // no Sunday ship-out
      var spread = parseInt(box.getAttribute('data-spread-days'), 10);
      if (isNaN(spread) || spread < 0) spread = 0;
      // data-extra-days: days added on top of the table row. Used by the cart
      // when the order contains UV DTF, which is printed by an outside shop and
      // therefore leaves one day later. Absent/0 on product pages, so their
      // behaviour is unchanged.
      // 19 Sep 2026: UV gets NO extra day here — the merchant decided every
      // cart shows the same date (UV buyers already see the extra time on the
      // product page). The cart still sets data-extra-days; it is ignored.
      var extra = 0;
      var first = addDays(basis, TABLE[basis.getDay()] + extra);
      var last = addDays(first, spread);
      // 24 Sep 2026: no Saturday delivery either (Saturday is a ship-out day,
      // not a delivery day). A range ending on Saturday rolls to Monday.
      if (last.getDay() === 6) last = addDays(last, 2);
      if (last.getDay() === 0) last = addDays(last, 1);
      var opts = { weekday: 'short', month: 'short', day: 'numeric' };
      dateEl.textContent = spread > 0
        ? first.toLocaleDateString('en-US', opts) + ' – ' + last.toLocaleDateString('en-US', opts)
        : first.toLocaleDateString('en-US', { weekday: 'long', month: 'short', day: 'numeric' });

      if (!noteEl) return;
      // 24 Sep 2026: the countdown now runs to the REAL ship-out cutoff
      // (06:00 Istanbul on the ship-out day computed above, Sunday skipped),
      // not to a US afternoon hour. It is shown only in the last 12 hours
      // before that cutoff (≈ 11:00–23:00 New York), so it never reads
      // "23h" or "39h". While it is hidden, the free-shipping line shows.
      var nowTR = nowIn(SHIP_TZ);
      var shipCut = new Date(basis.getTime()); shipCut.setHours(SHIP_CUTOFF_HOUR, 0, 0, 0);
      var s = Math.floor((shipCut.getTime() - nowTR.getTime()) / 1000);
      var open = s > 0 && s <= COUNTDOWN_WINDOW_HOURS * 3600;
      noteEl.hidden = !open;
      if (shipEl) shipEl.hidden = open;
      if (open && timeEl) {
        var h = Math.floor(s / 3600), m = Math.floor((s % 3600) / 60);
        timeEl.textContent = h > 0 ? h + 'h ' + pad(m) + 'm' : m + 'm';
      }
    }
    render();
    setInterval(render, 30000);
    // Exposed so the cart sync script can repaint immediately after a
    // cart change instead of waiting for the next 30s tick.
    window.dtfjDeliveryRender = render;
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
